import { CustomAppLayout } from '../../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
//Acution Market Theory
import { FormField, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { format, parse } from 'date-fns';
import React, { useEffect, useState } from 'react';
import BadgeUserType from '../../../../../../components/extras/BadgeUserType';
import Favorites from '../../../../../../components/extras/Favorites';
import MPModal from '../../../../../../components/MPModal';
import { fetchWithWatch } from '../../../../../../hooks/fetchWithWatch';
import { buildBreadcrumbItems, formatCurrency, getCookie, getUrlVersion, getUser, setLoading, setParameters } from '../../../../../commons/functions';
const _preserve = React.version;

export const AdminMovementsPACChargesPage = () => {
    const { data, menu, parameters } = useGlobalState();
    useGlobalState();
    const [PACS, setPACS] = useState<any[]>();


    const handleRefresh = async () => {
        ///private/user/movements/pac/initsubscription
        setLoading(true);
        try {
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/pac/list',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({ orderBy: "dateCreated", order: "desc", month: parameters?.month, year: parameters?.year, type: "charge" }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();

            if (dataWeb.code == 0) {
                setPACS(dataWeb.pacs)
            }
        } catch (error: any) {
        } finally { setLoading(false); }
    }
    useEffect(() => {
        handleRefresh();
    }, [parameters.period]);

    const error = (item: any) => {
        if (item) {
            if (item === "login_invalid_credentials")
                return "Credenciales inválidas";
            else if (item === "login_credentials_locked")
                return "Credenciales bloquedas";
            else if (item === "authorization_failed")
                return "Autorización fallida";
            else if (item === "authorization_timeout")
                return "Autorización expirada";
            else if (item === "request_timeout")
                return "Tiempo de espera agotado";
            else if (item === "subscription_intent_expired")
                return "Intento de suscripción expirado";
            else if (item === "internal_error")
                return "Error interno";
            else if (item === "insufficient_funds")
                return "Fondos insuficientes";
            else if (item === "subscription_inactive")
                return "Convenio inactivo";
            else if (item === "charge_amount_limit_exceeded")
                return "Límite de monto excedido";
            else if (item === "other")
                return "Error desconocido";

        } else {
            return ""
        }

    }

    const status = (item: any, data: any) => {
        if (item === "succeeded") {
            return <FormField label={"Ejecutado"}>Mov {data.idMovement}</FormField>;
        } else if (item === "created") {
            return <FormField label={"Pendiente"}></FormField>;
        } else if (item === "failed") {
            return <FormField label={"Error"}></FormField>;
        } else {
            return <em>{item}</em>;
        }

    }

    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}>Cargos PAC</Header>
                    <FormField label={`Periodo`}>
                        <MPModal date={parameters.period}
                            width={120}
                            end={new Date()}
                            onConfirm={(obj) => {
                                setParameters({ ...parameters, month: obj.month, year: obj.year, period: obj.period });
                            }} />

                    </FormField>
                    {!!PACS && (


                        <Table
                            variant='embedded'
                            columnDefinitions={[
                                {
                                    id: "user",
                                    header: "Usuario",
                                    cell: item => <FormField label={getUser(item.idUser, data).displayName}><BadgeUserType size='small' type='normal' idUserType={getUser(item.idUser, data).idUserType} /></FormField>


                                },
                                {
                                    id: "date",
                                    header: "Fecha",
                                    cell: item => <FormField label={format(parse(item.dateCreated, "dd-MM-yyyy HH:mm", new Date()), "dd-MM-yyyy")}>
                                        Act.{format(parse(item.dateUpdated, "dd-MM-yyyy HH:mm", new Date()), "dd-MM-yyyy")}
                                    </FormField>
                                },
                                {
                                    id: "Estado",
                                    header: "Estado",
                                    cell: item => status(item.status, item)

                                },
                                {
                                    id: "amount",
                                    header: "Monto",
                                    cell: item => formatCurrency(item.json.amount ?? 0, "CLP")

                                },
                            ]}
                            items={PACS || []}
                        />
                        /*subscriptions.filter((s: any) => s.subscription.id)*/
                    )}
                </SpaceBetween>
            }
        />
    )
};
